export default {
  name: 'form',
  translationKey: 'form-module',
  routePrefix: 'form',
  routeNamePrefix: 'admin.form',
  directRoutesAvailable: false,
}
